namespace RioERP.Orders {
    export interface OrderWebhookForm {
        SiteName: Serenity.StringEditor;
        OrderId: Serenity.IntegerEditor;
        Orderguid: Serenity.StringEditor;
        IsSynced: Serenity.BooleanEditor;
        hasError: Serenity.BooleanEditor;
        ErrorNote: Serenity.StringEditor;
        InsertDate: Serenity.DateEditor;
    }

    export class OrderWebhookForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderWebhook';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderWebhookForm.init)  {
                OrderWebhookForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.DateEditor;

                Q.initFormType(OrderWebhookForm, [
                    'SiteName', w0,
                    'OrderId', w1,
                    'Orderguid', w0,
                    'IsSynced', w2,
                    'hasError', w2,
                    'ErrorNote', w0,
                    'InsertDate', w3
                ]);
            }
        }
    }
}
